import React from "react";
import Slider from "react-slick";
import slider1 from '../../../images/slider1.png';
import slider2 from '../../../images/slider2.png';
import slider3 from '../../../images/slider3.png';

import logo_win from '../../../images/dispositivos/brand-win.png';
import logo_apple from '../../../images/dispositivos/brand-apple.png';

import logo_android from '../../../images/dispositivos/brand-android.png';
import logo_ios from '../../../images/dispositivos/brand-ios.png';

import logo_samsung from '../../../images/dispositivos/brand-samsung.png';
import logo_lg from '../../../images/dispositivos/brand-lg.png';
import logo_androidtv from '../../../images/dispositivos/brand-androidtv.png';

import star1 from '../../../images/planes/star1.svg';
import star2 from '../../../images/planes/star2.svg';
import star3 from '../../../images/planes/star3.svg';


export default function SimpleSlider() {
  var settings = {
    centerMode: true,
    centerPadding: '200px',
    slidesToShow: 1,
    responsive: [
        {
        breakpoint: 768,
        settings: {
            arrows: true,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 1
        }
        }
    ]
  };
  return (
      <>
        <section className="slider-section">
            <h3 className="titlesTn">LLEVA TU CONTENIDO <br />A DONDE VAYAS</h3>
            <div>
                <Slider {...settings}>
                <div>
                    <section className="slider">
                        <figure>  
                            <img src={slider1} alt="" title="" />
                        </figure>
                        <div className="slider__caption">
                            <h4><img src={star3} className="dispositivo-star" />Desde tu ordenador</h4>
                            <ul className="slider-list">
                                <li>
                                    <div className="slider-list__left">
                                        <figure class="brand-content">  
                                            <img src={logo_win} className="win" />
                                        </figure>
                                    </div>
                                    <div>
                                        <p><b>Para Windows</b><br />
                                        Internet Explorer 6 o posterior, Microsoft Edge, <br />
                                        Google Chrome, Mozila Firefox 2 o posterior, Opera.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className="slider-list__left">
                                        <figure class="brand-content">
                                            <img src={logo_apple} className="apple" />
                                        </figure>
                                    </div>
                                    <div>
                                        <p><b>Para Macintosh</b><br />
                                        Safari 3 o posterior, Google Chrome, Mozilla Firefox <br />
                                        2 o posterior, Opera.</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </section>
                </div>
                <div>
                    <section className="slider">
                        <figure>  
                            <img src={slider2} alt="" title="" />
                        </figure>
                        <div className="slider__caption">
                            <h4 className="color-light-blue"><img src={star2} className="dispositivo-star" />Smart TV</h4>
                            <ul className="slider-list">
                                <li>
                                    <div className="slider-list__left">
                                        <figure class="brand-content">  
                                            <img src={logo_samsung} className="samsung" />
                                        </figure>
                                    </div>
                                    <div>
                                        <p><b>Smart TV Samsung</b><br />
                                        (SO Tizen - Version 3.5 (1251) en adelante).</p>
                                    </div>
                                </li>
                                <li>
                                    <div className="slider-list__left">
                                        <figure class="brand-content">
                                            <img src={logo_lg} className="lg" />
                                        </figure>
                                    </div>
                                    <div>
                                        <p><b>Smart TV LG</b><br />
                                        (SO Tizen - Version 3 en adelante).</p>
                                    </div>
                                </li>
                                <li>
                                    <div className="slider-list__left">
                                        <figure class="brand-content">
                                            <img src={logo_androidtv} className="androidtv" />
                                        </figure>
                                    </div>
                                    <div>
                                        <p><b>Smart TV Android TV</b><br />
                                        (Sony, Philips, TCL, Sharp, etc).</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </section>
                </div>
                <div>
                    <section className="slider">
                        <figure>  
                            <img src={slider3} alt="" title="" />
                        </figure>
                        <div className="slider__caption">
                            <h4 className="color-pink"><img src={star1} className="dispositivo-star" />Smartphone</h4>
                            <ul className="slider-list">
                                <li>
                                    <div className="slider-list__left">
                                        <figure class="brand-content">  
                                            <img src={logo_android} className="android" />
                                        </figure>
                                    </div>
                                    <div>
                                        <p><b>Android</b><br />
                                        (Version 8 en adelante).</p>
                                    </div>
                                </li>
                                <li>
                                    <div className="slider-list__left">
                                        <figure class="brand-content">  
                                            <img src={logo_ios} className="ios" />
                                        </figure>
                                    </div>
                                    <div>
                                        <p><b>IOS</b><br />
                                        (Version 11 en adelante).</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </section>
                </div>
                </Slider>
            </div>
    </section>
    </>
  );
}